package org.multipaz.utopia.generated

/**
 * Generated strings for language: cs
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_cs = mapOf(
    "boarding_pass_attribute_departure_time" to "Čas odletu",
    "boarding_pass_attribute_flight_number" to "Číslo letu",
    "boarding_pass_attribute_passenger_name" to "Jméno cestujícího",
    "boarding_pass_attribute_seat_number" to "Číslo sedadla",
    "boarding_pass_description_departure_time" to "Datum a čas odletu",
    "boarding_pass_description_flight_number" to "Číslo letu",
    "boarding_pass_description_passenger_name" to "Příjmení nebo primární identifikátor držitele mDL.",
    "boarding_pass_description_seat_number" to "Číslo sedadla",
    "cor_attribute_administrative_number" to "Administrativní číslo",
    "cor_attribute_date_of_arrival" to "Datum příjezdu",
    "cor_attribute_date_of_birth" to "Datum narození",
    "cor_attribute_date_of_expiry" to "Datum platnosti",
    "cor_attribute_date_of_issue" to "Datum vydání",
    "cor_attribute_document_number" to "Číslo dokladu",
    "cor_attribute_family_name" to "Příjmení",
    "cor_attribute_gender" to "Pohlaví",
    "cor_attribute_given_names" to "Křestní jména",
    "cor_attribute_issuing_authority" to "Vydávající úřad",
    "cor_attribute_issuing_country" to "Vydávající země",
    "cor_attribute_issuing_jurisdiction" to "Vydávající jurisdikce",
    "cor_attribute_nationality" to "Státní příslušnost",
    "cor_attribute_older_than_18" to "Starší 18 let",
    "cor_attribute_older_than_21" to "Starší 21 let",
    "cor_attribute_place_of_birth" to "Místo narození",
    "cor_attribute_resident_address" to "Adresa pobytu",
    "cor_attribute_resident_city" to "Město pobytu",
    "cor_attribute_resident_country" to "Země pobytu",
    "cor_attribute_resident_house_number" to "Číslo domu pobytu",
    "cor_attribute_resident_postal_code" to "PSČ pobytu",
    "cor_attribute_resident_state" to "Stát pobytu",
    "cor_attribute_resident_street" to "Ulice pobytu",
    "cor_description_administrative_number" to "Číslo přiřazené poskytovatelem COR pro auditní kontrolu nebo jiné účely.",
    "cor_description_date_of_arrival" to "Den, měsíc a rok, kdy držitel COR dorazil do EU.",
    "cor_description_date_of_birth" to "Den, měsíc a rok narození držitele COR. Pokud neznámé, přibližné datum narození.",
    "cor_description_date_of_expiry" to "Datum (a případně čas) vypršení platnosti COR.",
    "cor_description_date_of_issue" to "Datum (a případně čas) vydání COR.",
    "cor_description_document_number" to "Číslo pro COR, přiřazené poskytovatelem COR.",
    "cor_description_family_name" to "Současné příjmení či primární identifikátor držitele COR",
    "cor_description_gender" to "Pohlaví držitele COR.",
    "cor_description_given_names" to "Současné křestní jméno, jiná jména, nebo sekundární identifikátor držitele COR",
    "cor_description_issuing_authority" to "Název správního orgánu, který vydal tuto instanci COR, nebo kód země ISO 3166 Alpha-2 příslušného členského státu, pokud neexistuje samostatný orgán oprávněný vydávat COR.",
    "cor_description_issuing_country" to "Kód země Alpha-2, jak je definováno v ISO 3166-1, země nebo území vydávajícího orgánu.",
    "cor_description_issuing_jurisdiction" to "Kód dílčího územního celku jurisdikce, která vydala COR, jak je definováno v ISO 3166-2:2020, klauzule 8. První část kódu MUSÍ být stejná jako hodnota pro issuing_country.",
    "cor_description_nationality" to "Kód země Alpha-2 dle ISO 3166-1, udávající státní příslušnost uživatele.",
    "cor_description_older_than_18" to "Starší 18 let?",
    "cor_description_older_than_21" to "Starší 21 let?",
    "cor_description_place_of_birth" to "Místo narození držitele COR.",
    "cor_description_resident_address" to "Úplná adresa místa, kde držitel COR aktuálně bydlí a/nebo kde jej lze kontaktovat (ulice/číslo popisné, obec atd.)",
    "cor_description_resident_city" to "Město, kde držitel COR aktuálně bydlí.",
    "cor_description_resident_country" to "Země, ve které uživatel aktuálně bydlí, jako dvoupísmenný kód země podle ISO 3166-1",
    "cor_description_resident_house_number" to "Číslo popisné/orientační, kde uživatel aktuálně bydlí, včetně případné přípony či předpony.",
    "cor_description_resident_postal_code" to "Poštovní směrovací číslo místa, kde držitel COR aktuálně bydlí.",
    "cor_description_resident_state" to "Stát, provincie, okres nebo místní oblast, kde uživatel aktuálně bydlí.",
    "cor_description_resident_street" to "Název ulice, kde uživatel aktuálně bydlí.",
    "cor_request_age_over_18" to "Věk nad 18 let",
    "cor_request_all_data_elements" to "Všechny údaje",
    "cor_request_mandatory_data_elements" to "Povinné údaje",
    "document_display_name_boarding_pass" to "Palubní lístek",
    "document_display_name_certificate_of_residency" to "Potvrzení o bydlišti",
    "document_display_name_german_personal_id" to "Německý občanský průkaz",
    "document_display_name_loyalty_card" to "Věrnostní karta",
    "document_display_name_movie_ticket" to "Vstupenka do kina",
    "document_display_name_naturalization_certificate" to "Osvědčení o nabytí státního občanství",
    "document_display_name_payment_card" to "Platební karta",
    "german_id_attribute_administrative_number" to "Správní číslo",
    "german_id_attribute_age_in_years" to "Věk v letech",
    "german_id_attribute_city_of_birth" to "Město narození",
    "german_id_attribute_country_of_birth" to "Země narození",
    "german_id_attribute_date_of_birth" to "Datum narození",
    "german_id_attribute_date_of_expiry" to "Datum platnosti",
    "german_id_attribute_date_of_issue" to "Datum vydání",
    "german_id_attribute_document_number" to "Číslo dokladu",
    "german_id_attribute_family_name" to "Příjmení",
    "german_id_attribute_family_name_at_birth" to "Rodné příjmení",
    "german_id_attribute_gender" to "Pohlaví",
    "german_id_attribute_given_names" to "Křestní jména",
    "german_id_attribute_issuing_authority" to "Vydávající orgán",
    "german_id_attribute_issuing_country" to "Vydávající země",
    "german_id_attribute_issuing_jurisdiction" to "Vydávající jurisdikce",
    "german_id_attribute_nationality" to "Národnost",
    "german_id_attribute_older_than_12" to "Starší 12 let",
    "german_id_attribute_older_than_14" to "Starší 14 let",
    "german_id_attribute_older_than_16" to "Starší 16 let",
    "german_id_attribute_older_than_18" to "Starší 18 let",
    "german_id_attribute_older_than_21" to "Starší 21 let",
    "german_id_attribute_older_than_65" to "Starší 65 let",
    "german_id_attribute_place_of_birth" to "Místo narození",
    "german_id_attribute_resident_address" to "Adresa bydliště",
    "german_id_attribute_resident_city" to "Město bydliště",
    "german_id_attribute_resident_country" to "Země bydliště",
    "german_id_attribute_resident_postal_code" to "PSČ bydliště",
    "german_id_attribute_state_of_birth" to "Stát narození",
    "german_id_attribute_year_of_birth" to "Rok narození",
    "german_id_description_administrative_number" to "Číslo přiřazené Poskytovatelem PID pro kontrolu auditu nebo jiné účely.",
    "german_id_description_age_in_years" to "Věk držitele PID v letech",
    "german_id_description_city_of_birth" to "Obec, město nebo vesnice, kde se uživatel PID narodil",
    "german_id_description_country_of_birth" to "Země, kde se uživatel PID narodil, ve formátu dvoupísmenného kódu země dle ISO 3166-1",
    "german_id_description_date_of_birth" to "Den, měsíc a rok narození držitele PID. Pokud není známo, přibližné datum narození.",
    "german_id_description_date_of_expiry" to "Datum (a případně čas) vypršení platnosti PID.",
    "german_id_description_date_of_issue" to "Datum (a případně čas) vydání PID.",
    "german_id_description_document_number" to "Číslo pro PID, přiřazené Poskytovatelem PID.",
    "german_id_description_family_name" to "Aktuální příjmení (příjmení, rodná jména) nebo primární identifikátor držitele PID",
    "german_id_description_family_name_at_birth" to "Příjmení nebo primární identifikátor držitele PID při narození",
    "german_id_description_gender" to "Pohlaví držitele PID",
    "german_id_description_given_names" to "Aktuální křestní jméno/jména, jiná jména nebo sekundární identifikátor držitele PID",
    "german_id_description_issuing_authority" to "Název správního orgánu, který vydal tuto instanci PID, nebo kód země ISO 3166 Alpha-2 příslušného členského státu, pokud neexistuje samostatný orgán oprávněný k vydávání PID.",
    "german_id_description_issuing_country" to "Kód země Alpha-2, jak je definováno v ISO 3166-1, země nebo území vydávajícího orgánu.",
    "german_id_description_issuing_jurisdiction" to "Kód územní jednotky země jurisdikce, která vydala PID, jak je definováno v ISO 3166-2:2020, klauzule 8. První část kódu MUSÍ být shodná s hodnotou issuing_country.",
    "german_id_description_nationality" to "Seznam kódů země Alpha-2 dle ISO 3166-1, představující státní příslušnost uživatele PID.",
    "german_id_description_older_than_12" to "Věk nad 12 let?",
    "german_id_description_older_than_14" to "Věk nad 14 let?",
    "german_id_description_older_than_16" to "Věk nad 16 let?",
    "german_id_description_older_than_18" to "Věk nad 18 let?",
    "german_id_description_older_than_21" to "Věk nad 21 let?",
    "german_id_description_older_than_65" to "Věk nad 65 let?",
    "german_id_description_place_of_birth" to "Země a obec nebo stát/provincie, kde se držitel PID narodil",
    "german_id_description_resident_address" to "Úplná adresa místa, kde držitel PID aktuálně bydlí a/nebo kde jej lze kontaktovat (ulice/číslo popisné, obec atd.)",
    "german_id_description_resident_city" to "Město, kde držitel PID aktuálně bydlí",
    "german_id_description_resident_country" to "Země, kde uživatel PID aktuálně bydlí, ve formátu kódu země Alpha-2 dle ISO 3166-1",
    "german_id_description_resident_postal_code" to "Poštovní směrovací číslo místa, kde držitel PID aktuálně bydlí",
    "german_id_description_state_of_birth" to "Stát, provincie, okres nebo místní oblast, kde se uživatel PID narodil",
    "german_id_description_year_of_birth" to "Rok narození držitele PID",
    "german_id_request_age_over_18" to "Věk nad 18 let",
    "german_id_request_all_data_elements" to "Všechny datové prvky",
    "german_id_request_mandatory_data_elements" to "Povinné datové prvky",
    "loyalty_attribute_date_of_expiry" to "Datum platnosti",
    "loyalty_attribute_date_of_issue" to "Datum vydání",
    "loyalty_attribute_family_name" to "Příjmení",
    "loyalty_attribute_given_names" to "Jméno",
    "loyalty_attribute_membership_id" to "Členské číslo",
    "loyalty_attribute_photo_of_holder" to "Fotografie držitele",
    "loyalty_attribute_tier" to "Úroveň",
    "loyalty_description_date_of_expiry" to "Datum vypršení platnosti dokladu",
    "loyalty_description_date_of_issue" to "Datum vydání dokladu",
    "loyalty_description_family_name" to "Příjmení, rodné příjmení nebo primární identifikátor držitele dokladu",
    "loyalty_description_given_names" to "Křestní jméno (jména), jiná jména nebo sekundární identifikátor držitele dokladu",
    "loyalty_description_membership_id" to "Identifikátor osoby držitele věrnostního ID.",
    "loyalty_description_photo_of_holder" to "Reprodukce portrétu držitele dokladu.",
    "loyalty_description_tier" to "Úroveň členství (základní, stříbrná, zlatá, platinová, elitní)",
    "loyalty_request_all_data_elements" to "Všechny datové prvky",
    "loyalty_request_mandatory_data_elements" to "Povinné datové prvky",
    "movie_ticket_attribute_age_rating_code" to "Kód věkového hodnocení",
    "movie_ticket_attribute_cinema_theater" to "Kino",
    "movie_ticket_attribute_date_and_time_of_show" to "Datum a čas představení",
    "movie_ticket_attribute_movie_poster" to "Filmový plakát",
    "movie_ticket_attribute_movie_title" to "Název filmu",
    "movie_ticket_attribute_parking" to "Parkování",
    "movie_ticket_attribute_seat" to "Sedadlo",
    "movie_ticket_attribute_theater" to "Kino",
    "movie_ticket_attribute_ticket_number" to "Číslo vstupenky",
    "movie_ticket_description_age_rating_code" to "Kód věkového hodnocení filmu pro věková omezení.",
    "movie_ticket_description_cinema_theater" to "Název kina a/nebo adresa/lokalita vstupu.",
    "movie_ticket_description_date_and_time_of_show" to "Datum a čas začátku filmu",
    "movie_ticket_description_movie_poster" to "Filmový plakát",
    "movie_ticket_description_movie_title" to "Název filmu, titul a jakékoli další identifikační informace o představení.",
    "movie_ticket_description_parking" to "Příznak, zda je parkování předplaceno při nákupu vstupenky.",
    "movie_ticket_description_seat" to "Číslo nebo kód sedadla (např. řada/sedadlo).",
    "movie_ticket_description_theater" to "Název nebo číslo sálu ve víceplátnovém kině.",
    "movie_ticket_description_ticket_number" to "Identifikační/referenční číslo vstupenky vydané při nákupu.",
    "movie_ticket_request_all_data_elements" to "Všechny datové prvky",
    "movie_ticket_request_prepaid_parking" to "Předplacené parkování",
    "movie_ticket_request_ticket_number" to "Číslo vstupenky",
    "naturalization_attribute_date_of_birth" to "Datum narození",
    "naturalization_attribute_date_of_naturalization" to "Datum naturalizace",
    "naturalization_attribute_family_name" to "Příjmení",
    "naturalization_attribute_given_names" to "Křestní jména",
    "naturalization_description_date_of_birth" to "Den, měsíc a rok narození naturalizované osoby. V případě neznámé hodnoty přibližné datum narození.",
    "naturalization_description_date_of_naturalization" to "Datum (a případně čas), kdy osoba byla naturalizována.",
    "naturalization_description_family_name" to "Aktuální příjmení nebo hlavní identifikátor naturalizované osoby",
    "naturalization_description_given_names" to "Aktuální křestní jméno (jména), jiná jména nebo sekundární identifikátor naturalizované osoby",
    "naturalization_request_all_data_elements" to "Všechny údaje",
    "payment_attribute_expiry_date" to "Datum vypršení platnosti",
    "payment_attribute_holder_name" to "Jméno držitele",
    "payment_attribute_issue_date" to "Datum vydání",
    "payment_attribute_issuer_name" to "Název vydavatele",
    "payment_attribute_masked_account_reference" to "Maskované referenční číslo účtu",
    "payment_attribute_payment_instrument_id" to "ID platebního nástroje",
    "payment_description_expiry_date" to "Datum, kdy toto pověření vyprší.",
    "payment_description_holder_name" to "Jméno držitele platebního účtu.",
    "payment_description_issue_date" to "Datum vydání tohoto pověření.",
    "payment_description_issuer_name" to "Čitelný název vydavatele.",
    "payment_description_masked_account_reference" to "Maskovaný odkaz na účet, například poslední 4 číslice PAN.",
    "payment_description_payment_instrument_id" to "Tokenizovaný identifikátor platebního nástroje.",
    "payment_request_payment_sca_all" to "Platba SCA (všechny datové prvky)",
    "payment_request_payment_sca_minimal" to "Platba SCA (minimální)",
    "payment_request_payment_sca_transaction" to "Ověření SCA s platební transakcí"
)
